/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractTemplateBasicInfo = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    name: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
